import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { CreateApiKeyPayload, CreatedApiKey } from "../../../../../api/apiKeys"
import { useApi } from "../../../../hooks/useApi"

export const API_KEYS_QUERY_KEY = ["api_keys"]

export const useApiKeys = () => {
  const { scientApi } = useApi()
  const { data, error, isLoading } = useQuery(API_KEYS_QUERY_KEY, scientApi.apiKeys.list, {
    retry: 1,
  })
  return { apiKeys: data, error: error as AxiosError, isLoading }
}

export const useCreateApiKeyMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess: (created: CreatedApiKey) => void
  onError: (error: AxiosError) => void
}) => {
  const { scientApi } = useApi()
  const queryClient = useQueryClient()
  return useMutation((payload: CreateApiKeyPayload) => scientApi.apiKeys.create(payload), {
    onSuccess: created => {
      queryClient.invalidateQueries(API_KEYS_QUERY_KEY)
      onSuccess(created)
    },
    onError,
  })
}

export const useRevokeApiKeyMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void
  onError: (error: AxiosError) => void
}) => {
  const { scientApi } = useApi()
  const queryClient = useQueryClient()
  return useMutation((id: number) => scientApi.apiKeys.revoke(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(API_KEYS_QUERY_KEY)
      onSuccess()
    },
    onError,
  })
}
